import PinnedModal from './PinnedModal'

export default PinnedModal
